export default __webpack_public_path__ + "static/media/teamBgMb.e8640410.png";